import React from 'react';
import UserInfo from '~c/UserInfo';
import routes from '~/apiRouter';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import {sentUsersBrowserData} from '../../../pages/EventReg/utils';
import PopupClose from '../Close';
import PolicyMessage from '../../PolicyMessage';

class Subscribe extends React.Component {
  state = {
    user: {},
    events: [],
    customFieldId: '',
    errorMessage: '',
    checkAll: false,
    isPolicyAgreed: true,
    eventsLoaderSpinnerState: spinnerStates.done,
    subscribeLoaderSpinnerState: spinnerStates.done,
    isSubscribed: false
  };

  policyRef = React.createRef();

  getUser = user => {
    this.setState({ user });
  };

  preflightCheck = () => {
    const { events } = this.state;

    const checks = [true];
    const isPolicyAgreed = this.policyRef.current.checked;
    checks.push(isPolicyAgreed);

    checks.push(this.userInfoInstance?.checkVisibleFields());

    this.setState({ isPolicyAgreed });
    return checks.every(item => item === true);
  };

  onSubscribeClick = () => {
    if (this.state.isPolicyAgreed && this.state.user.length === 0 || this.state.isPolicyAgreed && this.state.user.length !== 0) {
      const {user} = this.state;
      sentUsersBrowserData({
        data: user,
        isNewsSubscribe: user.subscribe,
        isPolicyAgreed: this.state.isPolicyAgreed
      });
    }

    if (this.preflightCheck()) {
      const {user, events, customFieldId } = this.state;

      const options = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          NAME: `${user.firstname}`,
          EMAIL: user.email,
        }),
      };

      this.setState({
        subscribeLoaderSpinnerState: spinnerStates.pending,
        errorMessage: '',
      });
      fetch(routes.subscribe.post, options)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.status === 'success') {
            this.setState({
              isSubscribed: true,
            });
          }
          if (json.status === 'error') {
            this.setState({
              errorMessage: json.errors[0].message,
              subscribeLoaderSpinnerState: spinnerStates.done,
            });
          }
        })
        .catch(() => {
          this.setState({
            errorMessage: messages.serverTimeout,
            subscribeLoaderSpinnerState: spinnerStates.done,
          });
        });
    }
  };

  render() {
    const { isSubscribed } = this.state;

    return (
        <div className="popup popup-subs">
          <div className="popup__close-container"><PopupClose/></div>
          <div className="popup-subs__header">
            <div className="collage__descr txt-accent popup-subs__descr">
            <p className="heading heading--1">Подписаться на рассылку</p>
            </div>
          </div>

          {!isSubscribed ? (
            <React.Fragment>
              <div className="popup-subs__field">
                <UserInfo
                  showFields={{
                    firstname: true,
                    email: true,
                  }}
                  showBlocks={{ contact: true }}
                  showСheckNews={false}
                  userInfoCb={this.getUser}
                  ref={instance => {
                    this.userInfoInstance = instance;
                  }}
                />
              </div>

              <footer className="popup-subs__footer">
                <div className="check popup-subs__check">
                  <label className="check__label" htmlFor="check_policy">
                    <input
                      autoComplete="off"
                      className="check__inp"
                      type="checkbox"
                      name="policy"
                      id="check_policy"
                      ref={this.policyRef}
                      required="required"
                      onChange={e => {
                        this.setState({ isPolicyAgreed: e.target.checked });
                      }}
                    />
                    <span
                      className={
                        this.state.isPolicyAgreed
                          ? 'check__box'
                          : 'check__box check__box--error'
                      }
                    ></span>
                    <PolicyMessage/>
                  </label>
                </div>

                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={this.onSubscribeClick}
                >
                  {this.state.subscribeLoaderSpinnerState ===
                  spinnerStates.done ? (
                    'Подписаться'
                  ) : (
                    <React.Fragment>
                      <div className="invisible">Подписаться</div>
                      <Loader
                        spinnerState={this.state.spinnerState}
                        spinnerPosition={spinnerPositions.absolute}
                        className="loader--white"
                      />
                    </React.Fragment>
                  )}
                </button>
                {this.state.errorMessage !== '' ? (
                  <div className="error error--red">
                    {this.state.errorMessage}
                  </div>
                ) : null}
              </footer>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="popup-subs__field">
                <h4 className="heading heading--2">Поздравляем!</h4>
                <p className="txt">Подписка успешно оформлена.</p>
              </div>
              <footer className="popup-subs__footer">
                <button
                  type="button"
                  className="btn btn--primary"
                  onClick={() => {
                    $.magnificPopup.close();
                  }}
                >
                  Закрыть
                </button>
              </footer>
            </React.Fragment>
          )}
        </div>
    );
  }
}

export default Subscribe;
